import { on } from '@ember/modifier';
import Component from '@glimmer/component';

/**
 * @typedef {object} PixStepArgs
 * @property {number} index - Position de l'étape dans la liste, à partir de 0. Le numéro affiché en découle.
 * @property {string} [title] - Intitulé de l'étape.
 * @property {string} [subtitle] - Précision affichée sous l'intitulé.
 * @property {boolean} [isCurrent] - Désigne l'étape en cours.
 * @property {boolean} [isClickable] - Rend l'étape cliquable (affichée sous forme de bouton).
 * @property {() => void} [onClick] - Callback appelé au clic sur l'étape. Sans effet si `isClickable` n'est pas fourni.
 */

/**
 * @typedef {object} PixStepSignature
 * @property {HTMLLIElement} Element
 * @property {PixStepArgs} Args
 * @property {{}} Blocks
 */

export default class PixStepComponent extends Component {
  get cssClass() {
    const classes = ['pix-step'];

    if (this.args.isCurrent) {
      classes.push('pix-step--current');
    }

    return classes.join(' ');
  }

  get displayIndex() {
    return this.args.index + 1;
  }

  get ariaCurrent() {
    return this.args.isCurrent ? 'step' : null;
  }

  <template>
    <li class={{this.cssClass}} aria-current={{this.ariaCurrent}} ...attributes>
      {{#if @isClickable}}
        <button type="button" class="pix-step__button" {{on "click" @onClick}}>
          <div class="pix-step__index" aria-hidden="true"><span>{{this.displayIndex}}</span></div>
          {{#if @title}}<div
              class="pix-step__title {{if @hideLabel 'screen-reader-only'}}"
            >{{@title}}</div>{{/if}}
          {{#if @subtitle}}<div
              class="pix-step__subtitle {{if @hideLabel 'screen-reader-only'}}"
            >{{@subtitle}}</div>{{/if}}
        </button>
      {{else}}
        <div class="pix-step__index" aria-hidden="true"><span>{{this.displayIndex}}</span></div>
        {{#if @title}}
          <div class="pix-step__title {{if @hideLabel 'screen-reader-only'}}">
            {{@title}}
          </div>
        {{/if}}
        {{#if @subtitle}}
          <div class="pix-step__subtitle {{if @hideLabel 'screen-reader-only'}}">
            {{@subtitle}}
          </div>
        {{/if}}
      {{/if}}
    </li>
  </template>
}
